import SaveIcon from "assets/icon/SaveIcon"

export default function SmallButton(props){
    return(
        <button className="bg-black rounded-full py-1 px-3 text-sm text-white"
            onClick={ props?.onClick }
        >
            { props.title }
        </button>
    )
}